import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import FResourcePropertyAndOptionTipPopover from '@/components/FResourcePropertyAndOptionTipPopover';
import FIcons from '@/components/FIcons';

interface FResourcePropertiesProps {
  immutableData: {
    key: string;
    name: string;
    value: string;
    description: string;
  }[];
  onlyEditValueData: {
    key: string;
    name: string;
    value: string;
    description: string;
  }[];
  alterableData: {
    key: string;
    name: string;
    value: string;
    description: string;
  }[];
  keyMaxWidth?: number;
  valueMaxWidth?: number;
  keysSort?: string[];

  onEdit_onlyEditValueData?(
    value: FResourcePropertiesProps['onlyEditValueData'][number],
  ): void;

  onEdit_alterableData?(
    value: FResourcePropertiesProps['alterableData'][number],
  ): void;

  onDelete_alterableData?(
    value: FResourcePropertiesProps['alterableData'][number],
  ): void;
}

function FResourceProperties({
  immutableData,
  onlyEditValueData,
  alterableData,
  onEdit_onlyEditValueData,
  keyMaxWidth = 100,
  valueMaxWidth = 230,
  onEdit_alterableData,
  onDelete_alterableData,
  keysSort,
}: FResourcePropertiesProps) {
  // console.log(keysSort, 'keysSort sdijf;lksdjflkjsdlkjlkj');

  return (
    <div className={styles.styles}>
      {keysSort &&
        keysSort.map((k) => {
          const immutable = immutableData.find((dd) => {
            return dd.key === k;
          });
          if (immutable) {
            return (
              <React.Fragment key={immutable.key}>
                <div className={styles.grid1}>
                  <FResourcePropertyAndOptionTipPopover
                    info={{
                      key: immutable.key,
                      name: immutable.name,
                      description: immutable.description,
                    }}
                    type={'property'}
                  >
                    <FComponentsLib.FContentText
                      text={immutable.name}
                      type={'additional2'}
                      style={{ maxWidth: keyMaxWidth }}
                      singleRow
                    />
                  </FResourcePropertyAndOptionTipPopover>
                </div>
                <div>
                  <FComponentsLib.FContentText
                    text={immutable.value}
                    type={'highlight'}
                    style={{ fontSize: 12, maxWidth: valueMaxWidth }}
                    singleRow
                  />
                </div>
              </React.Fragment>
            );
          }

          const onlyEditValue = onlyEditValueData.find((dd) => {
            return dd.key === k;
          });

          if (onlyEditValue) {
            return (
              <React.Fragment key={onlyEditValue.key}>
                <div className={styles.grid1}>
                  <FResourcePropertyAndOptionTipPopover
                    info={{
                      key: onlyEditValue.key,
                      name: onlyEditValue.name,
                      description: onlyEditValue.description,
                    }}
                    type={'property'}
                  >
                    <FComponentsLib.FContentText
                      text={onlyEditValue.name}
                      type={'additional2'}
                      style={{ maxWidth: keyMaxWidth }}
                      singleRow
                    />
                  </FResourcePropertyAndOptionTipPopover>
                </div>
                <div className={styles.grid2}>
                  {onlyEditValue.value === '' ? (
                    <i style={{ fontSize: 12, color: '#999' }}>待填写</i>
                  ) : (
                    <FComponentsLib.FContentText
                      text={onlyEditValue.value}
                      type={'highlight'}
                      style={{ fontSize: 12, maxWidth: valueMaxWidth }}
                      singleRow
                    />
                  )}

                  {onEdit_onlyEditValueData && (
                    <FComponentsLib.FTextBtn
                      type={'default'}
                      onClick={() => {
                        onEdit_onlyEditValueData &&
                          onEdit_onlyEditValueData(onlyEditValue);
                      }}
                    >
                      <FIcons.FCircleDelete style={{ fontSize: 14 }} />
                    </FComponentsLib.FTextBtn>
                  )}
                </div>
              </React.Fragment>
            );
          }

          return null;
        })}
      {!keysSort && (
        <>
          {immutableData.map((d) => {
            return (
              <React.Fragment key={d.key}>
                <div className={styles.grid1}>
                  <FResourcePropertyAndOptionTipPopover
                    info={{
                      key: d.key,
                      name: d.name,
                      description: d.description,
                    }}
                    type={'property'}
                  >
                    <FComponentsLib.FContentText
                      text={d.name}
                      type={'additional2'}
                      style={{ maxWidth: keyMaxWidth }}
                      singleRow
                    />
                  </FResourcePropertyAndOptionTipPopover>
                </div>
                <div>
                  <FComponentsLib.FContentText
                    text={d.value}
                    type={'highlight'}
                    style={{ fontSize: 12, maxWidth: valueMaxWidth }}
                    singleRow
                  />
                </div>
              </React.Fragment>
            );
          })}

          {onlyEditValueData.map((d) => {
            return (
              <React.Fragment key={d.key}>
                <div className={styles.grid1}>
                  <FResourcePropertyAndOptionTipPopover
                    info={{
                      key: d.key,
                      name: d.name,
                      description: d.description,
                    }}
                    type={'property'}
                  >
                    <FComponentsLib.FContentText
                      text={d.name}
                      type={'additional2'}
                      style={{ maxWidth: keyMaxWidth }}
                      singleRow
                    />
                  </FResourcePropertyAndOptionTipPopover>
                </div>
                <div className={styles.grid2}>
                  {d.value === '' ? (
                    <i style={{ fontSize: 12, color: '#999' }}>待填写</i>
                  ) : (
                    <FComponentsLib.FContentText
                      text={d.value}
                      type={'highlight'}
                      style={{ fontSize: 12, maxWidth: valueMaxWidth }}
                      singleRow
                    />
                  )}

                  {onEdit_onlyEditValueData && (
                    <FComponentsLib.FTextBtn
                      type={'default'}
                      onClick={() => {
                        onEdit_onlyEditValueData && onEdit_onlyEditValueData(d);
                      }}
                    >
                      <FIcons.FCircleDelete style={{ fontSize: 14 }} />
                    </FComponentsLib.FTextBtn>
                  )}
                </div>
              </React.Fragment>
            );
          })}
        </>
      )}

      {alterableData.map((d) => {
        return (
          <React.Fragment key={d.key}>
            <div className={styles.grid1}>
              <FResourcePropertyAndOptionTipPopover
                info={{
                  key: d.key,
                  name: d.name,
                  description: d.description,
                }}
                type={'property'}
              >
                <FComponentsLib.FContentText
                  text={d.name}
                  type={'additional2'}
                  singleRow
                  style={{ maxWidth: keyMaxWidth }}
                />
              </FResourcePropertyAndOptionTipPopover>
            </div>
            <div className={styles.grid2}>
              {d.value === '' ? (
                <i style={{ fontSize: 12, color: '#999' }}>待填写</i>
              ) : (
                <FComponentsLib.FContentText
                  text={d.value}
                  type={'highlight'}
                  style={{ fontSize: 12, maxWidth: valueMaxWidth }}
                  singleRow
                />
              )}

              {onEdit_alterableData && (
                <FComponentsLib.FTextBtn
                  type={'default'}
                  onClick={() => {
                    onEdit_alterableData && onEdit_alterableData(d);
                  }}
                >
                  <FIcons.FCircleDelete style={{ fontSize: 14 }} />
                </FComponentsLib.FTextBtn>
              )}
              {onDelete_alterableData && (
                <FComponentsLib.FTextBtn
                  type={'danger'}
                  onClick={() => {
                    onDelete_alterableData && onDelete_alterableData(d);
                  }}
                >
                  <FIcons.FCircleEdit style={{ fontSize: 14 }} />
                </FComponentsLib.FTextBtn>
              )}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default FResourceProperties;
